import React from 'react';
import { ThemeProvider } from '@sls-react/design-system';
import SessionContainer from '@sls-react/contexts/SessionContext';
import { DeviceContext } from './DeviceContext';
import SaleContainer from './SaleContext';
import { ChromelessContext } from '@sls-react/contexts/ChromelessContext';
import { ModalsContainer } from '@sls-react/contexts/ModalsContext';
import { InitialData } from '@sls-react/lib/initialData/initialData';
import { AbTestContext } from './AbTestContext';
import { ServerSideCookiesContext } from './ServerSideCookies';

interface Props extends Omit<InitialData, 'pageProps'> {}

const GlobalContexts: React.FC<Props> = ({
  abTests,
  children,
  chromeless,
  device,
  initialSessionState,
  sales,
  serverSideCookies,
}) => (
  <ThemeProvider>
    <ServerSideCookiesContext.Provider value={serverSideCookies || {}}>
      <DeviceContext.Provider value={device}>
        <SessionContainer.Provider initialState={initialSessionState}>
          <SaleContainer.Provider initialState={sales}>
            <ChromelessContext.Provider value={chromeless}>
              <ModalsContainer.Provider initialState={{ modals: [] }}>
                <AbTestContext.Provider value={abTests}>
                  {children}
                </AbTestContext.Provider>
              </ModalsContainer.Provider>
            </ChromelessContext.Provider>
          </SaleContainer.Provider>
        </SessionContainer.Provider>
      </DeviceContext.Provider>
    </ServerSideCookiesContext.Provider>
  </ThemeProvider>
);

export default GlobalContexts;
